import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export const requestNotificationPermission = async () => {
  if (!('Notification' in window)) return false;
  if (Notification.permission === 'granted') return true;
  if (Notification.permission === 'denied') return false;
  const permission = await Notification.requestPermission();
  return permission === 'granted';
};

export const subscribeToPush = async () => {
  try {
    const hasPermission = await requestNotificationPermission();
    if (!hasPermission) return false;

    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
      console.log('Push not supported');
      return false;
    }

    // Wait for service worker
    const registration = await navigator.serviceWorker.ready;

    // Get VAPID public key
    const vapidKey = process.env.REACT_APP_VAPID_PUBLIC_KEY;
    if (!vapidKey) {
      console.error('VAPID public key not configured');
      return false;
    }

    // Check existing subscription
    let subscription = await registration.pushManager.getSubscription();

    if (!subscription) {
      // Create new subscription
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(vapidKey),
      });
    }

    // Send subscription to backend
    const token = localStorage.getItem('token');
    await axios.post(`${API}/push/subscribe`, subscription.toJSON(), {
      headers: { Authorization: `Bearer ${token}` },
    });

    console.log('Push subscription active');
    return true;
  } catch (err) {
    console.error('Push subscription failed:', err);
    return false;
  }
};

export const showNotification = (title, options = {}) => {
  if (!('Notification' in window)) return null;
  if (Notification.permission !== 'granted') return null;

  // Use Service Worker notifications (works on mobile)
  if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.showNotification(title, {
        body: options.body || '',
        icon: '/icon-192.png',
        badge: '/icon-192.png',
        vibrate: [200, 100, 200],
        tag: options.tag || 'callchat-notification',
        renotify: true,
        requireInteraction: options.requireInteraction || false,
        data: { url: window.location.origin, ...options.data },
      });
    });
    return true;
  }

  // Fallback: desktop notification
  try {
    const notification = new Notification(title, {
      icon: '/icon-192.png',
      body: options.body || '',
      tag: options.tag || 'callchat-notification',
    });
    notification.onclick = () => { window.focus(); notification.close(); };
    return notification;
  } catch {
    return null;
  }
};

export const isNotificationSupported = () => 'Notification' in window;
export const getNotificationPermission = () => {
  if (!isNotificationSupported()) return 'unsupported';
  return Notification.permission;
};
